import ModalPro from '@/components/ModalPro/index.vue'
import SiderPro from '@/components/SiderPro/index.vue'
import TablePro from '@/components/TableProV2/index'
import FormPro from '@/components/FormPro/index.vue'
import RowPro from '@/components/RowPro/index.vue'
import ColPro from '@/components/ColPro/index.vue'
// import UploadPro from '@/components/UploadPro/index'
import PageHeader from '@/layout/pageHeader.vue'
import { App } from 'vue'

export default function (app: App) {
  app.component('modal-pro', ModalPro)
  app.component('sider-pro', SiderPro)
  app.component('table-pro', TablePro)
  app.component('form-pro', FormPro) // 别问问什么是oo， 问就是这样比较帅
  app.component('l-row', RowPro)
  app.component('l-col', ColPro)
  // app.component('upload-pro', UploadPro)
  app.component('page-header', PageHeader)
}
